import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';
import { UtilsService } from '../../services/utils.service'
import { Router } from '@angular/router';
@Component({
  selector: 'production-decisions',
  standalone: true,
  imports: [
    CommonModule,
       FormsModule,   // <-- make sure FormsModule is listed here
  ],
  templateUrl: './production-decisions.component.html',
  styleUrl: './production-decisions.component.css'
})
export class ProductionDecisionsComponent implements OnInit {
  ProdD: any = null;
  RO: any = null;
  validationError = '';

  constructor(private router: Router, private api: PlayerApiService, private playerData: PlayerDataService, private utils: UtilsService) {}

  async ngOnInit() {
    this.ProdD =
      (await this.playerData.getPageDecisionData('production')) || {
        F_current: 0,
        F_investment: 0,
        F_sold: 0,
        R_existing: 0,
        R_bought: 0,
        allocations: [],
      };
      console.log("In prod init");
      console.log(this.ProdD);
      const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    this.RO = roCached;
    console.log(this.RO);
  }

  onInputChange() {
    this.playerData.setPageDecisionData('production', this.ProdD);
  }

  validatePercent(prod: any) {
    let total1 = 0; 
    let total2 = 0
    for (let i = 0; i< this.ProdD.allocations.length; i++){
      total1 =total1 +  Number(this.ProdD.allocations[i].WorkForceP  || 0);
total2 =total2 +  Number(this.ProdD.allocations[i].AutomationP  || 0);
    }
      
    if (total1 !== 100) {
      this.validationError = `⚠️ Sum of  Labor %  should be 100 (current: ${total1}).  `;
    } else {
      this.validationError = '';
    }
    if (total2 !== 100) {
      this.validationError = this.validationError +`⚠️ Sum of  Robots %  should be 100 (current: ${total2}).  `;
    } else {
      this.validationError = this.validationError +'';
    }
    this.onInputChange();
  }
}
